/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/inviteUser.config.json";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { SEND_COMMITTE_MEMBER_INVITES, SendDiscount } from "../graphql";
import { VApplication } from "../../../application";
import notification from "../config/notifications.config.json";
import axios from "axios";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { pretty } from "@vlinder-web/utils-react";

const log: any = LoggerModule?.getInstance();
const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};


export interface ISenddiscountInviteMethods extends IPluginMethodMap {
  senddiscountInviteUser(args: any): Promise<any>;
}

export class SenddiscountInviteUserService implements IAgentPlugin {
  readonly methods: ISenddiscountInviteMethods;

  constructor() {
    this.methods = {
      senddiscountInviteUser: this.senddiscountInviteUser.bind(this),
    };
  }

  async senddiscountInviteUser(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    console.log(args)

    try {
      if (client) {
        const res1 = await client.mutate({
          mutation: SendDiscount,
          variables: {
            data: {
              discountId: args?.discount,
              count: parseInt(args?.discountCount || 0),
              status: "AssignedToCommittee",
              committeeId: args?.userEmail,
            },
          },
          fetchPolicy: "no-cache",
        });
        if (res1?.data) {
          return {
            ...res1?.data?.updateDiscountStatus,
          }
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      console.log(
        `_display_message?.extensions?.display_message`,
        _display_message?.extensions?.display_message
      );
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
}
